import { render, staticRenderFns } from "./WeeklyWorkDangjinDetail.vue?vue&type=template&id=48a382e9&scoped=true"
import script from "./WeeklyWorkDangjinDetail.vue?vue&type=script&lang=js"
export * from "./WeeklyWorkDangjinDetail.vue?vue&type=script&lang=js"
import style0 from "./WeeklyWorkDangjinDetail.vue?vue&type=style&index=0&id=48a382e9&prod&scoped=true&lang=css"
import style1 from "./WeeklyWorkDangjinDetail.vue?vue&type=style&index=1&id=48a382e9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a382e9",
  null
  
)

export default component.exports